/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreatePricingPlanRequest
 */
export interface CreatePricingPlanRequest {
    /**
     * 
     * @type {string}
     * @memberof CreatePricingPlanRequest
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePricingPlanRequest
     */
    fees: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreatePricingPlanRequest
     */
    automatic: boolean;
}

/**
 * Check if a given object implements the CreatePricingPlanRequest interface.
 */
export function instanceOfCreatePricingPlanRequest(value: object): value is CreatePricingPlanRequest {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('fees' in value) || value['fees'] === undefined) return false;
    if (!('automatic' in value) || value['automatic'] === undefined) return false;
    return true;
}

export function CreatePricingPlanRequestFromJSON(json: any): CreatePricingPlanRequest {
    return CreatePricingPlanRequestFromJSONTyped(json, false);
}

export function CreatePricingPlanRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreatePricingPlanRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'fees': json['fees'],
        'automatic': json['automatic'],
    };
}

export function CreatePricingPlanRequestToJSON(value?: CreatePricingPlanRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'name': value['name'],
        'fees': value['fees'],
        'automatic': value['automatic'],
    };
}

